(ns nl.mediquest.ui.css
  (:require
   [garden.core :as garden]
   [garden.types]))

(defn- css->str [values]
  (garden/css {:vendors ["webkit"]}
              values))

(defn- dom-head []
  (or js/document.head
      (aget (js/document.getElementsByTagName "head") 0)))

(defn- add-styles-to-tag [tag styles]
  (if (.-styleSheet tag)
    (set! (.. tag -styleSheet -cssText) (css->str styles))
    (.appendChild tag (js/document.createTextNode (css->str styles)))))

(defn- create-new-style-tag! [id]
  (let [tag (js/document.createElement "style")]
    (.appendChild (dom-head) tag)
    (set! (.-type tag) "text/css")
    (set! (.-id tag) id)
    tag))

(defn- create-new-link-tag! [id href]
  (let [tag (js/document.createElement "link")]
    (.appendChild (dom-head) tag)
    (set! (.-type tag) "text/css")
    (set! (.-rel tag) "stylesheet")
    (set! (.-id tag) id)
    (set! (.-href tag) href)
    tag))

(defn keyframes [k frames]
  (garden.types/CSSAtRule. :keyframes
                           {:identifier (name k)
                            :frames frames}))

(defn px [v]
  (str v "px"))

(defn inject-styles! [id styles]
  (if-let [tag (js/document.getElementById id)]
    (set! (.. tag -innerHTML) (css->str styles))
    (-> (create-new-style-tag! id)
        (add-styles-to-tag styles))))

(defn inject-stylesheet! [id href]
  (when-not (js/document.getElementById id)
    (create-new-link-tag! id href)))

(def level-bgs-0
  {:level/error "bg-red-600"
   :level/success "bg-green-500"
   :level/warning "bg-yellow-500"})

(def level-bgs-1
  {:level/error "bg-red-700"
   :level/success "bg-green-600"
   :level/warning "bg-yellow-600"})

(def level-icons
  {:level/error :fa-times
   :level/success :fa-check
   :level/warning :fa-info})
